import { Line, mixins } from 'vue-chartjs';

export default {
  name: 'line-chart',
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    extraOptions: Object,
    gradientColors: {
      type: Array,
      default: () => [
        'rgba(72,72,176,0.2)',
        'rgba(72,72,176,0.0)',
        'rgba(119,52,169,0)'
      ],
      // validator: val => {
      //   return val.length > 1;
      // }
    },
    gradientStops: {
      type: Array,
      default: () => [1, 0.4, 0],
      // validator: val => {
      //   return val.length > 1;
      // }
    }
  },
  data() {
    return {
      ctx: null
    };
  },
  methods: {
    updateGradients(chartData) {
      if (!chartData) return;

      if (chartData.datasets.length > 1) {

        let totalGraph = this.gradientColors.length / 3;
        let gradient = []
        let stop = [];

        // Storing Gradient colors for each graph
        for (let i = 0; i < totalGraph; i++) {
          window["_gradient" + i] = new Array();
        }
        // Storing Stop of colors for each graph
        for (let i = 0; i < totalGraph; i++) {
          window["_stop" + i] = new Array();
        }

        // Storing Stop in array
        for (let i = 0; i < totalGraph; i++) {
          for (let j = 0; j < 3; j++) {
            window["_stop" + i].push(this.gradientStops.shift())
          }
          window["_stop" + i].reverse()
          stop.push(window["_stop" + i])
        }

        // Storing Gradient in array
        for (let i = 0; i < totalGraph; i++) {
          for (let j = 0; j < 3; j++) {
            window["_gradient" + i].push(this.gradientColors.shift())
          }
          window["_gradient" + i].reverse()
          gradient.push(window["_gradient" + i])
        }

        for (let i = 0; i < chartData.datasets.length; i++) {
          const ctx =
            this.ctx || document.getElementById(this.chartId).getContext('2d');
          const gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

          for (let j = 0; j < 3; j++) {
            gradientStroke.addColorStop(stop[i][j], gradient[i][j]);
          }

          if (!chartData.datasets[i].backgroundColor) {
            chartData.datasets[i].backgroundColor = gradientStroke;
          }
        }
      } else {

        const ctx =
          this.ctx || document.getElementById(this.chartId).getContext('2d');
        const gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

        this.gradientStops.forEach((stop, index) => {
          gradientStroke.addColorStop(stop, this.gradientColors[index]);
        });
        chartData.datasets.forEach(set => {
          if (!set.backgroundColor) {
            set.backgroundColor = gradientStroke;
          }
        });
      }

    }
  },
  mounted() {
    this.$watch(
      'chartData',
      (newVal, oldVal) => {
        this.updateGradients(this.chartData);
        if (!oldVal) {
          this.renderChart(this.chartData, this.extraOptions);
        }
      },
      { immediate: true }
    );
  }
};
